module.exports = __webpack_public_path__ + "media/images/icons/fb-8684521cfcd2afe33fb80662d95c353c.svg";